var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":_vm.position === 'bottom',"top":_vm.position === 'top',"left":_vm.position === 'left',"right":_vm.position === 'right'},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',{staticClass:"info-tooltip"},[_c('img',_vm._g(_vm._b({attrs:{"src":require("@/assets/icons/info.png")}},'img',attrs,false),on))])]}}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }